export default __webpack_public_path__ + "static/media/E05.e78d942c.mp3";